/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Card } from 'reactstrap';
import { IEveFormContainerViewProps } from './eve-form-container';

export default (props: IEveFormContainerViewProps) => {
    let items = [];
    items = props.slots && props.slots.content && props.slots.content.length > 0 ? props.slots.content : [];
    return <Card className={'eve-form__container container'}>{items}</Card>;
};
